<template>
  <div class="">
    <van-nav-bar title="资金开票" left-arrow @click-left="onClickLeft" />
  </div>
</template>

<script>
export default {
  name: '',
  components: {

  },
  data() {
    return {

    }
  },
  created() {

  },
  methods: {
    onClickLeft() {
      window.history.go(-1)
    }
  }
}
</script>

<style lang="less" scoped>

</style>
